import './styles/tokens.css';
import './styles/globals.css';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { StrictMode, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import { AppThemeProvider, useAppTheme, QueryProvider } from './contexts';
import { createAppTheme } from './theme';

/**
 * Inner wrapper that reads the current theme from context
 * and provides the matching MUI theme.
 */
function MuiThemeWrapper({ children }: { children: React.ReactNode }) {
  const { theme: mode } = useAppTheme();
  const muiTheme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <HelmetProvider>
      <AppThemeProvider>
        <MuiThemeWrapper>
          <QueryProvider>
            <App />
          </QueryProvider>
        </MuiThemeWrapper>
      </AppThemeProvider>
    </HelmetProvider>
  </StrictMode>,
);
